import { actionTypes } from 'app/types/action_types';

const initialState = {
  showVideoSubscriptions: false,
};

const mapPayload = (payload) => {
  if (Object.keys(payload).length === 0) return initialState;

  return {
    activeSubscriptionType: payload.active_subscription_type,
    eligibleForSelfUpgrade: payload.eligible_for_self_upgrade,
    eligibleForNewCustomerOfferPPV: payload.eligible_for_new_customer_ppv_offer,
  };
};

// eslint-disable-next-line default-param-last
const musicPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapPayload(action.payload);
    default:
      return state;
  }
};

export default musicPageReducer;
